module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/backArrow@3x-c3e53345f8b83e5ca4614cc847908e8b.png";